import { useState } from "react";
import { Link } from "react-router-dom";

/*
 * Replace the typographic mark by saving your logo as one of:
 *   /app/frontend/public/logo.png  (or .svg / .jpg / .webp)
 * The component auto-loads it. No other changes needed.
 */
const LOGO_SRC = "/logo.png";

export default function Logo({ variant = "header", className = "" }) {
  const [imgOk, setImgOk] = useState(true);

  const sizes = {
    header: "h-10 md:h-12",
    footer: "h-12 md:h-14",
  };

  return (
    <Link to="/" data-testid="site-logo" className={`flex items-center gap-3 shrink-0 group ${className}`} aria-label="The Indian Marketing — Home">
      {imgOk ? (
        <img
          src={LOGO_SRC}
          alt="The Indian Marketing"
          onError={() => setImgOk(false)}
          className={`${sizes[variant]} w-auto object-contain transition-opacity duration-300 group-hover:opacity-90`}
        />
      ) : (
        <div className="flex flex-col leading-none">
          <span className="font-playfair text-white text-xl md:text-2xl tracking-tight">
            THE INDIAN <span className="text-[#D4AF37]">MARKETING</span>
          </span>
          <span className="font-outfit text-[10px] tracking-[0.25em] text-[#D9D9D9]/70 uppercase mt-1">
            A Studio for Brand Craft
          </span>
        </div>
      )}
    </Link>
  );
}
